import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import { ga } from 'helpers/multitrack';
import { ResponsiveCarousel } from '../ResponsiveCarousel/ResponsiveCarousel';
import { VenueListItem } from '../VenueListItem/VenueListItem';
export var VenueCarousel = function VenueCarousel(_ref) {
  var elements = _ref.elements,
      header = _ref.header,
      loading = _ref.loading,
      nolink = _ref.nolink,
      type = _ref.type,
      showCount = _ref.showCount;
  return React.createElement(ResponsiveCarousel, {
    extraClass: classNames('carousel--venues', _defineProperty({}, "carousel--venues-".concat(type), type)),
    handleDwell: function handleDwell() {
      return ga('Venue Details', 'View Module', "venues_".concat(type), 0, {
        nonInteraction: true
      });
    },
    header: header,
    loading: loading,
    type: type
  }, (elements || []).slice(0, 20).map(function (item) {
    return React.createElement(VenueListItem, {
      type: type,
      key: item.id,
      venueId: item.id,
      activities: item.activities,
      imageUrl: item.images && item.images.default || '',
      name: item.name,
      subtitle: item.subtitle,
      hood: item.location && item.location.name || '',
      alias: item.alias,
      rating: item.ratings && item.ratings.mean > 0 ? item.ratings.mean : -1,
      nolink: nolink,
      showRatingNumber: !showCount,
      count: showCount && "".concat(item.ratings.display_total, " ratings")
    });
  }));
};
VenueCarousel.propTypes = {
  elements: PropTypes.array,
  header: PropTypes.string,
  loading: PropTypes.bool,
  nolink: PropTypes.bool,
  type: PropTypes.string,
  showCount: PropTypes.bool
};